/*
  lien-reveal.js — kaydırmayla ortaya çıkma (scroll-reveal)

  NEDEN bu kadar küçük: ürün sayfaları Meta reklam trafiği alacak; mobil +
  60fps pazarlık konusu değil. Tek bir IntersectionObserver, yalnız
  transform/opacity animasyonu, gözlem sonrası bağlantı kesilir.

  NEDEN `lien-reveal-ready`: gizli başlangıç hâli CSS'te
  `.lien-reveal-ready [data-lien-reveal]:not(.is-in)` ile sınırlı. JS hiç
  yüklenmezse (ad-blocker, ağ hatası) bu sınıf eklenmez ve içerik
  görünür kalır — içerik asla JS'e rehin olmaz.

  NEDEN reduced-motion kontrolü burada da var: CSS geçişi zaten kapatıyor
  ama gözlemciyi hiç kurmamak daha ucuz; hepsini anında `is-in` yapıyoruz.
*/
(function () {
  var root = document.documentElement;
  var SELECTOR = '[data-lien-reveal]';
  var reduce = false;
  try {
    reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* matchMedia yoksa animasyon açık kalır, sorun değil */ }

  function stagger(el) {
    /* Çocuklara --i sıra numarası: CSS gecikmeyi bundan hesaplar.
       Liquid tarafında elle verilmiş --i varsa dokunmayız. */
    var kids = el.querySelectorAll('[data-lien-reveal-child]');
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].style.getPropertyValue('--i')) kids[i].style.setProperty('--i', String(i));
    }
  }

  function showAll() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.add('lien-reveal-ready');
    showAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var en = entries[i];
      if (!en.isIntersecting) continue;
      en.target.classList.add('is-in');
      io.unobserve(en.target); /* Bir kez açılır; geri kaydırınca kapanmaz. */
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

  function observe(scope) {
    var els = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      if (els[i].classList.contains('is-in')) continue;
      stagger(els[i]);
      io.observe(els[i]);
    }
  }

  /* Sınıf, gözlem başlamadan hemen önce eklenir: önce gizle sonra gözle
     sırası ters olursa ekranda "görünür → gizli" titremesi olur. */
  root.classList.add('lien-reveal-ready');
  observe(document);

  /* Tema düzenleyici bölümü yeniden basınca yeni düğümleri de gözle. */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
